
export class LeverantorsKlassning {
    static readonly A = "A";
    static readonly B = "B";
    static readonly C = "C";
    static readonly D = "D";
}
